module.exports = __webpack_public_path__ + "static/media/big_unicorn.61817843.png";